export function createStorage() {
  let UNSET = Symbol();
  let s: Storage = {} as Storage;

  Object.defineProperty(s, "setItem", {
    get: () => {
      return (k: string, v = UNSET) => {
        if (v === UNSET) {
          throw new TypeError(
            `Failed to execute 'setItem' on 'Storage': 2 arguments required, but only 1 present.`
          );
        }
        s[String(k)] = String(v);
      };
    },
  });

  Object.defineProperty(s, "getItem", {
    get: () => {
      return (k: string) => {
        if (s.hasOwnProperty(String(k))) {
          return s[String(k)];
        } else {
          return null;
        }
      };
    },
  });

  Object.defineProperty(s, "removeItem", {
    get: () => {
      return (k: string) => {
        if (s.hasOwnProperty(String(k))) {
          delete s[String(k)];
        }
      };
    },
  });

  Object.defineProperty(s, "clear", {
    get: () => {
      return () => {
        for (let k in s) {
          delete s[String(k)];
        }
      };
    },
  });

  Object.defineProperty(s, "length", {
    get: () => {
      return Object.keys(s).length;
    },
  });

  Object.defineProperty(s, "key", {
    value: (i: number) => {
      let key = Object.keys(s)[i];
      return !key ? null : key;
    },
  });

  return s;
}
